import * as actionTypes from '../actionTypes';

export const toggle_expand_view = () => {
    return {
        type: actionTypes.SETTINGS_TOGGLE_EXPAND
    }
};
